function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const React = require("react");
import { CookiebarLayout } from "./cookiebarLayout";
import { acceptAllCookies, denyAllCookies } from "./cookiebarState";
import { getCookie, setCookie } from "../../../../Shared/utils/cookies";
import { acceptCookies, denyCookies } from "../../../../Shared/utils/datalayer.mapping";
export class Cookiebar extends React.Component {
    componentDidUpdate(prevProps, prevState) {
        const currentVideoCookies = getCookie("video-cookies") === "true";
        if (this.state.videoCookies !== currentVideoCookies) {
            this.setState({
                videoCookies: currentVideoCookies
            });
        }
    }
    componentDidMount() {
        const currentVideoCookies = getCookie("video-cookies") === "true";
        this.setState({
            videoCookies: currentVideoCookies
        });
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.visible !== nextProps.visible || this.state.expanded !== nextState.expanded || this.state.videoCookies !== nextState.videoCookies;
    }
    render() {
        if (!this.props.visible) return /*#__PURE__*/ _jsx(_Fragment, {});
        return /*#__PURE__*/ _jsx(CookiebarLayout, {
            cookiebarRef: this.cookiebar,
            expanded: this.state.expanded,
            toggleExpand: this.toggleExpand,
            videoCookies: this.state.videoCookies,
            toggleVideoCookies: this.toggleVideoCookies,
            savePreferences: this.savePreferences,
            onAcceptAllCookies: this.handleAcceptAllCookies,
            onDenyAllCookies: this.handleDenyAllCookies
        });
    }
    constructor(props){
        super(props), _define_property(this, "cookiebar", React.createRef()), _define_property(this, "toggleExpand", ()=>{
            this.setState((prevState)=>({
                    expanded: !prevState.expanded
                }));
        }), _define_property(this, "toggleVideoCookies", ()=>{
            this.setState((prevState)=>{
                const newValue = !prevState.videoCookies;
                setCookie("video-cookies", newValue.toString(), 365);
                return {
                    videoCookies: newValue
                };
            });
        }), _define_property(this, "savePreferences", ()=>{
            if (this.state.videoCookies) {
                acceptCookies();
            } else {
                denyCookies();
            }
            this.props.showCookiebar(false);
        }), _define_property(this, "handleAcceptAllCookies", ()=>{
            acceptAllCookies(()=>{
                this.setState({
                    videoCookies: true
                });
            });
        }), _define_property(this, "handleDenyAllCookies", ()=>{
            denyAllCookies(()=>{
                this.setState({
                    videoCookies: false
                });
            });
        });
        this.state = {
            expanded: false,
            videoCookies: getCookie("video-cookies") === "true"
        };
    }
}
export const showCookiebarLink = (p)=>/*#__PURE__*/ _jsx("a", {
        href: "",
        onClick: (e)=>{
            e.preventDefault();
            p.showCookiebar(true);
        },
        children: "Cookie-instellingen"
    });
